import { render } from "./Footer.vue?vue&type=template&id=1c5fb2d9"
const script = {}

import exportComponent from "/home/runner/work/meedly-vueportfolio/meedly-vueportfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__